import React from "react";
import Select from "react-select";
import classNames from "classnames";

const CustomSelect = ({
  name,
  className,
  placeholder,
  options,
  value,
  isClearable,
  onChange,
  required,
  ...props
}) => {
  const handleChange = (data) => {
    onChange && onChange(data?.value);
  };

  /*  const validateField = (value) => {
    let error;
    if (required && value === undefined) {
      error = "This field is required";
    }
    return error;
  }; */

  return (
    <React.Fragment>
      <Select
        className={classNames("full-width", className)}
        classNamePrefix="select"
        placeholder={placeholder || "Please select"}
        name={name}
        options={options}
        onChange={handleChange}
        isClearable={!!isClearable}
        value={options ? options.find((option) => option.value == value) ?? null : null}
        {...props}
      />
    </React.Fragment>
  );
};

export default CustomSelect;
